<template>
  <div class="rating-chart-legend">
    <ReviewsAnalystRatingsChartLegendItem
      v-for="rating of Object.keys(ratingDistribution).reverse()"
      v-show="ratingDistribution[rating].count"
      :key="rating"
      :rating="parseInt(rating)"
      :count="ratingDistribution[rating].count"
    ></ReviewsAnalystRatingsChartLegendItem>
  </div>
</template>

<script>
import ReviewsAnalystRatingsChartLegendItem from "@/components/Reviews/Analyst/ReviewsAnalystRatingsChartLegendItem";

export default {
  name: "ReviewsAnalystRatingsChartLegend",
  components: {
    ReviewsAnalystRatingsChartLegendItem
  },
  props: {
    ratingDistribution: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-chart-legend {
  flex-basis: 280px;
}
</style>
